module.exports = __webpack_public_path__ + "static/media/wendy_cabrera_rubio_3.65ce5d80.jpg";